import object from 'common/helpers/primitives/object'


interface LinkAutotest {
  disabled?: boolean // ?
  auth?: boolean
  screenshot?: boolean
  currentPath?: string
  XSSParams?: string[]
  redirect?: boolean
  features?: {
    [key: string]: boolean
  }
  abTests?: {
    [key: string]: {
      value: 'a' | 'b' | 'c'
    }
  }
}

interface LinkAnalytics {
  page?: string
  pageType?: string
  flow?: string
}

interface LinkObject {
  path: string
  analytics?: LinkAnalytics
  autotest?: LinkAutotest | LinkAutotest[]
}

interface Links {
  [name: string]: LinkObject | {
    [name: string]: LinkObject
  }
}

interface AbsoluteLinks {
  [path: string]: string | {
    [path: string]: AbsoluteLinks
  }
}

/*
  Generates absolute and relative paths.
  Relative paths good to use in routing and absolute in Link component.

  From:

  {
    register: { path: 'register', name: 'register' },
    profile: {
      root: { path: 'profile', name: 'profile' },
      orders: { path: 'orders', name: 'profile orders' },
      rates: {
        root: { path: 'rates', name: 'profile rates' },
        perfumes: { path: 'perfumes', name: 'profile perfume rates' },
        colognes: { path: 'colognes', name: 'profile cologne rates' },
      },
    },
  }

  Creates:

  {
    register: '/register',
    profile: {
      root: '/profile',
      orders: '/profile/orders',
      rates: {
        root: '/profile/rates',
        perfumes: '/profile/rates/perfumes',
        colognes: '/profile/rates/colognes',
      },
    },
  }

 */
const generateAbsoluteLinks = <M, K extends keyof M, T extends { [I in K]: AbsoluteLinks }>(links: M, rootPath: string = ''): T =>
  <T>object.mapValues(links as unknown as object, (link: Links, key: string) => {
    if ('path' in link) {
      if (key === 'root') {
        return rootPath
      }

      return `${rootPath}/${link.path}`
    }

    if (!link.root) {
      throw new Error('Missed `root` property in links object')
    }

    return generateAbsoluteLinks(link, `${rootPath}/${link.root.path}`)
  })


export default generateAbsoluteLinks
